var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.publisherWarnings.length)?_c('v-icon',{staticClass:"mx-2",attrs:{"small":"","color":"warning"}},[_vm._v(" mdi-alert-outline ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }